import type * as React from 'react';
import { put } from '@Domain/Api';
import type { RetentionSettingsPayload } from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsFetched';
import retentionSettingsUpdated, {
	type RetentionSettingsUpdatedAction,
} from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsUpdated';
import retentionSettingsUpdateFailed, {
	type RetentionSettingsUpdateFailedAction,
} from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsUpdateFailed';
import type UpdateRetentionSettings from '@Application/Accounts/RetentionSettings/Commands/UpdateRetentionSettings';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = RetentionSettingsUpdatedAction | RetentionSettingsUpdateFailedAction;

export default (command: UpdateRetentionSettings) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<RetentionSettingsPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/retention-settings`,
				command.toJSON(),
			);

			const action = retentionSettingsUpdated(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = retentionSettingsUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
